<template>
  <div>
    <option-row title="ФИАС города:">{{ cityFiasId || "-" }}</option-row>
    <option-row title="ФИАС региона:">{{ regionFiasId || "-" }}</option-row>
  </div>
</template>

<script>
export default {
  name: "FiasInfo",
  props: {
    cityFiasId: { type: String, default: null },
    regionFiasId: { type: String, default: null },
  },
};
</script>
